const { getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

export const formatValue = value => {
    const lang = getLanguage();
    switch (lang) {
        case 'en':
            if (typeof value === 'string') {
                return value.toLocaleString('en-GB');
            } else {
                return Number(value)
                    .toFixed(2)
                    .toLocaleString('en-GB');
            }
        default:
            return formatAmount(Number(value).toFixed(2));
    }
};
